import { render, staticRenderFns } from "./PatientInfoItem.vue?vue&type=template&id=71b151e8&scoped=true&"
import script from "./PatientInfoItem.vue?vue&type=script&lang=ts&"
export * from "./PatientInfoItem.vue?vue&type=script&lang=ts&"
import style0 from "./PatientInfoItem.vue?vue&type=style&index=0&id=71b151e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b151e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VRow,VSpacer})
